"use client";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
type sideBar = {
  type: string;
  api_url: string;
  menu?: string;
  sidebarHeading: string;
};
interface REPORTMEUSCONFIG {
  reportdata: {
    header: string;
    description: string;
    order: number;
    activeReport?: {
      icon: string;
      menu: string;
      menu_description: string;
      url: string;
      method: string;
      filters: any;
      columns?: any;
      activeColumns?: any;
      sideBar?: any[] | undefined;
      headerSidebar?: any[] | undefined;
      innerFilters?: any[];
    };
    menus: {
      icon: string;
      menu: string;
      menu_description: string;
      url: string;
      method: string;
      filters: any;
      columns?: any;
      activeColumns?: any;
    }[];
  };
  // Add other properties as needed
}
export const ReportUi: React.FC<REPORTMEUSCONFIG> = ({reportdata}) => {
  const datas: NeoTableConfig = {
    title: reportdata?.activeReport?.menu
      ? reportdata?.activeReport?.menu
      : "Report",
    table: {
      columns: reportdata?.activeReport?.columns,
      activeColumns: reportdata?.activeReport?.activeColumns,
      activeFilters: reportdata?.activeReport?.filters,
      style: {
        height: "h-full"
      },
      meta: {
        id: 4,
        title: reportdata?.activeReport?.menu
          ? reportdata?.header + " ( " + reportdata?.activeReport?.menu + " ) "
          : "Report",
        description: "Total Data",
        hasSearch: false,
        hasUpload: false,
        hasDownload: true,
        hasAdd: false,
        hasActions: false,
        hasCheckbox: false,
        hasFilter: reportdata?.activeReport?.filters.length ? true : false,
        hasFooter: true,
        hasHeader: true,
        hasPagination: true,
        hasCreate: false
      },
      url: {
        page: {},
        api: {
          get: reportdata?.activeReport?.url
        }
      },
      sidebar: reportdata?.activeReport?.sideBar,
      headerSidebar: reportdata?.activeReport?.headerSidebar,
      actions: [],
      innerFilters: reportdata?.activeReport?.innerFilters
    }
  };
  //console.log(reportdata?.activeReport?.sideBar);
  const handleFilterSubmit = (req: any) => {};
  return (
    <>
      <div className="flex min-h-[calc(100vh-63px)] px-5 py-5">
        {/* {reportdata?.activeReport?.sideBar ? (
          <div className="w-[20%] bg-gray-100 p-2">
            {reportdata?.activeReport?.sideBar.map((sidebar, index) => {
              switch (sidebar.menu) {
                case "rfidLog":
                  return <RfidLog key={index} sideBar={sidebar} />;
                default:
                  return null;
              }
            })}
          </div>
        ) : (
          
        )} */}
        {/* <div className="flex-1 p-4"> */}
        {reportdata?.activeReport?.columns.length > 0 && (
          // <NeoTable table={datas.table} />
          <NeoAGgrid table={datas.table} />
        )}
        {/* </div> */}
      </div>
    </>
  );
};
